// Navigation for the main Rionick Studios header (desktop mega menus + mobile drawer).
// `href` = external site (opens in a new tab); `to` = page on this site.

export const solutions = [
  {
    title: "Ghar360",
    desc: "Interactive property walkthroughs for builders",
    icon: "fa-regular fa-house-chimney",
    to: "/ghar360",
  },
  {
    title: "ARRISE",
    desc: "AR for print, packaging and business cards",
    icon: "fa-regular fa-qrcode",
    to: "/arrise",
  },
  {
    title: "3D Product Viewer",
    desc: "Embed interactive 3D models on any website",
    icon: "fa-regular fa-cube",
    to: "/3D_Products",
  },
  {
    title: "3D Space",
    desc: "Free 3D models and animations",
    icon: "fa-regular fa-cubes",
    href: "https://3dspace.rionick.com/",
  },
];

export const services = [
  {
    title: "3D Modeling & Animation",
    desc: "Models, texturing, rigging and animation",
    icon: "fa-regular fa-cube",
    to: "/best-3d-services-india",
  },
  {
    title: "Viral CGI Videos",
    desc: "CGI ads, FOOH reels and 3D billboards",
    icon: "fa-regular fa-clapperboard",
    to: "/viral-cgi-videos",
  },
  {
    title: "Graphic Design",
    desc: "Logos, branding, illustration and game art",
    icon: "fa-regular fa-pen-nib",
    to: "/graphic-designing-services-india",
  },
  {
    title: "Game Development",
    desc: "2D and 3D Unity games for mobile",
    icon: "fa-regular fa-gamepad",
    to: "/game-development-services-india",
  },
  {
    title: "Digital Marketing",
    desc: "Social, content, SEO and paid ads",
    icon: "fa-regular fa-chart-line-up",
    to: "/best-digital-marketing-services-india",
  },
];

export const navItems = [
  { title: "Home", to: "/" },
  { title: "About", to: "/about-us" },
  { title: "Solutions", menu: "solutions", items: solutions },
  { title: "Services", menu: "services", items: services },
  { title: "Hall of Fame", to: "/hall-of-fame" },
  { title: "Contact", to: "/contact-us" },
];

export const contact = {
  phone: "+91 8377935429",
  phoneHref: "tel:+918377935429",
  email: "hello@rionick.com",
  whatsapp: "https://wa.me/918377935429",
};
